import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useProductNode from '../_PRODUCT/useProductNode.jsx'
import meta from './metaRulemrm.mjs'
import Model from './ModelRulemrm.mjs'
import PropertiesPane from './PropertiesPaneRulemrm.jsx'
import FormChoose from './FormChooseRulemrm.jsx'
import TableChoose from './TableChooseRulemrm.jsx'
import api from './apiRulemrm.mjs'

export default () => {
    const ProductNode = useProductNode()

    return extendNode(ProductNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
        Model,
        PropertiesPane,

        _pushDataSlots: {
            rulemRmRules: [],
        },

        _getCategories(map, node) {
            return [
                'RULEM_RM_IMPORTANT_RULE',
                'RULEM_RM_ATTACHMENT',
            ]
        },

        _getShape(map, node) {
            return 'EllipseRectangle'
        },

        _getThemeColor(map, node) {
            return Color.ORANGE
        },
    })
}
